import React, { Component } from "react";
import Image from '../fragments/Image';

export default class PageText extends Component {
  	
	render () {
		
		let block = this.props.block;
				
		if (block) {
									
		    return (
			    
			    <div id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--about c-text'}>
			    			    		
		    		<div className="l-grid">
		    		
		    			<div className="l-grid__col l-grid__col--m-4-12 l-grid__col--l-6-12 l-grid__col--xl-7-12">
		    			
		    				<h2 className="c-paragraph c-paragraph--space" dangerouslySetInnerHTML={ {__html: block.heading}}></h2>
							
						</div>
						
						<div className="l-grid__col l-grid__col--m-8-12 l-grid__col--l-6-12 l-grid__col--xl-5-12">
						
							{block.text &&
								<div className="scope-text scope-text--faded scope-text--body" dangerouslySetInnerHTML={{__html:block.text}}></div>
							}
							
						</div>
		    			
		    		</div>
			    					    
			    </div>
			)
			
		} else {
			
			return null;
		
		}
	}
}
